export const sellerConstants = {
    REQUEST_SELLERS: 'REQUEST_SELLERS',
    RECEIVE_SELLERS: 'RECEIVE_SELLERS',
    SELLER_ERROR: 'SELLER_ERROR',

    // Constants for add new seller
    ADD_SELLER_REQUEST: 'ADD_SELLER_REQUEST',
    ADD_SELLER_SUCCESS: 'ADD_SELLER_SUCCESS',
    ADD_SELLER_ERROR: 'ADD_SELLER_ERROR',

    REQUEST_COUNTRIES: 'REQUEST_COUNTRIES',
    RECEIVE_COUNTRIES: 'RECEIVE_COUNTRIES',
    COUNTRY_LIST_ERROR: 'COUNTRY_LIST_ERROR',

    REQUEST_SELLER_ADMIN: 'REQUEST_SELLER_ADMIN',
    RECEIVE_SELLER_ADMIN: 'RECEIVE_SELLER_ADMIN',
    SELLER_ADMIN_LIST_ERROR: 'SELLER_ADMIN_LIST_ERROR',

    REQUEST_CREDITS: 'REQUEST_CREDITS',
    RECEIVE_CREDITS: 'RECEIVE_CREDITS',
    CREDITS_ERROR: 'CREDITS_ERROR',

    REQUEST_UPDATE_SELLER: 'REQUEST_UPDATE_SELLER',
    UPDATE_SELLER_SUCCESS: 'UPDATE_SELLER_SUCCESS',
    UPDATE_SELLER_ERROR: 'UPDATE_SELLER_ERROR',

    REQUEST_ADD_SELLER_ADMIN: 'REQUEST_ADD_SELLER_ADMIN',
    ADD_SELLER_ADMIN_SUCCESS: 'ADD_SELLER_ADMIN_SUCCESS',
    ADD_SELLER_ADMIN_ERROR: 'ADD_SELLER_ADMIN_ERROR',

    REQUEST_ORGANISATIONS: 'REQUEST_ORGANISATIONS',
    RECEIVE_ORGANISATIONS: 'RECEIVE_ORGANISATIONS',
    ORGANISATINS_ERROR: 'ORGANISATINS_ERROR',

    // SELL CREDITS
    REQUEST_SELL_CREDITS: 'REQUEST_SELL_CREDITS',
    RECEIVE_SELL_CREDITS: 'RECEIVE_SELL_CREDITS',
    SELL_CREDITS_ERROR: 'SELL_CREDITS_ERROR',

    // REQUEST CREDITS
    REQUEST_REVOKE_CREDITS: 'REQUEST_REVOKE_CREDITS',
    RECEIVE_REVOKE_CREDITS: 'RECEIVE_REVOKE_CREDITS',
    REVOKE_CREDITS_ERROR: 'REVOKE_CREDITS_ERROR',

    // SELLER IMAGE
    REQUEST_ADD_SELLER_IMAGE:'REQUEST_ADD_SELLER_IMAGE',
    ADD_SELLER_IMAGE_SUCCESS: 'ADD_SELLER_IMAGE_SUCCESS',
    ADD_SELLER_IMAGE_ERROR:'ADD_SELLER_IMAGE_ERROR',

    // DELETE SELLER
    REQUEST_DELETE_SELLER: 'REQUEST_DELETE_SELLER',
    RECEIVE_DELETE_SELLER: 'RECEIVE_DELETE_SELLER',
    DELETE_SELLER_ERROR: 'DELETE_SELLER_ERROR',

    // MAKE SELLER PRIMARY ADMIN
    REQUEST_SELLER_PRIMARY_ADMIN: 'REQUEST_SELLER_PRIMARY_ADMIN',
    SELLER_PRIMARY_ADMIN_SUCCESS: 'SELLER_PRIMARY_ADMIN_SUCCESS',
    SELLER_PRIMARY_ADMIN_ERROR: 'SELLER_PRIMARY_ADMIN_ERROR',

    // REMOVE SELLER ADMIN
    REQUEST_REMOVE_SELLER_ADMIN: 'REQUEST_REMOVE_SELLER_ADMIN',
    REMOVE_SELLER_ADMIN_SUCCESS: 'REMOVE_SELLER_ADMIN_SUCCESS',
    REMOVE_SELLER_ADMIN_ERROR: 'REMOVE_SELLER_ADMIN_ERROR',
    
    // REMOVE_SELLER_IMAGE
    REQUEST_REMOVE_SELLER_IMAGE:'REQUEST_REMOVE_SELLER_IMAGE',
    REMOVE_SELLER_IMAGE_SUCCESS:'REMOVE_SELLER_IMAGE_SUCCESS',
    REMOVE_SELLER_IMAGE_ERROR:'REMOVE_SELLER_IMAGE_ERROR',
};



// WEBPACK FOOTER //
// ./src/_constants/seller.constants.js